<template>
    <label :for="id" class="form-image" :class="containerClass">
        <input
            :id="id"
            type="file"
            :accept="acceptedFiletypes"
            @change="onChange"
        >

        <template v-if="!preview && !previewUrl">
            <i class="form-image-icon" :class="iconClass" />
            <span v-if="selectLabel.length > 0" class="form-image-label">
                {{ selectLabel }}
            </span>
        </template>

        <template v-else>
            <img class="form-image-preview" :src="preview || previewUrl">
            <span v-if="changeLabel.length > 0" class="form-image-label">
                {{ changeLabel }}
            </span>
        </template>
    </label>
</template>
<script>
import { isString } from 'lodash';

export default {
    props: {
        id: {
            type: String,
            default: null,
        },
        accept: {
            type: [String, Array],
            default: null,
        },
        icon: {
            type: String,
            default: 'cloud-upload',
        },
        selectLabel: {
            type: String,
            default: 'Select image',
        },
        changeLabel: {
            type: String,
            default: 'Change image',
        },
        previewUrl: {
            type: String,
            default: null,
        },
        error: {
            type: Boolean,
            default: false,
        },
    },

    data: () => ({
        preview: false,
    }),

    computed: {
        /**
         * Compute accepted filetypes.
         *
         * @returns {string} List of accepted filetypes.
         */
        acceptedFiletypes() {
            if (isString(this.accept)) {
                return this.accept;
            }

            return this.accept.join(',');
        },

        /**
         * Compute container class.
         *
         * @returns {string} Container class.
         */
        containerClass() {
            return {
                previewing: !! this.preview || !! this.previewUrl,
                error: this.error,
            };
        },

        /**
         * Compute icon class.
         *
         * @returns {string} Icon class.
         */
        iconClass() {
            return `far fa-${this.icon}`;
        },
    },

    methods: {
        /**
         * Listenes for input "change" event.
         *
         * @param  {object} event Change event object.
         */
        onChange(event) {
            const file = event.target.files[0];

            this.loadPreview(file);
            this.$emit('change', file);
        },

        /**
         * Clears image preview.
         */
        clearPreview() {
            this.preview = null;
        },

        /**
         * Loads preview of image.
         *
         * @param  {File} file File to preview.
         */
        loadPreview(file) {
            this.preview = URL.createObjectURL(file);
        },
    },
};
</script>
